module.exports = __webpack_public_path__ + "assets/img/26_873.8685c866.jpg";